import { contentSectionCss } from "components/v3/ContentSection/ContentSection.css"
import { Footer } from "components/v3/Footer"
import { Header } from "components/v3/Header/Header"
import SocketProvider from "context/SocketContext"
import { type ReactElement } from "react"
import { twMerge } from "tailwind-merge"

export function V3StaticLayout(page: ReactElement) {
  return (
    <div className="h-auto md:h-full min-h-screen flex flex-col gap-0">
      <Header />
      <SocketProvider>
        <main
          id="main-content" // Needed for "Skip to content" link in Header
          className={twMerge(contentSectionCss, "px-2 pb-4")}
        >
          {page}
        </main>
      </SocketProvider>
      <Footer />
    </div>
  )
}
